import dayjs from "dayjs";
import { DataTable } from "@/components/tables";
import DeleteWithConfirm from "./DeleteWithConfirm";
import { getInstanceName } from "@/helpers/utils";
import { Rule } from "./UserGroupDetails.types";
import { DATASTORE_ENTITY_TYPE } from "./accessRules.constants";
import { Datastore } from "@/pages/datastores/types";

interface AccessRulesFlatTableProps {
  items: Rule[];
  datastores?: Datastore[];
  getUserName: (userId: string) => string;
  canManageRules: boolean;
  groupId?: string;
  refetch: () => void;
}

const AccessRulesFlatTable = ({
  items,
  datastores,
  getUserName,
  canManageRules,
  groupId,
  refetch,
}: AccessRulesFlatTableProps) => (
  <DataTable<Rule>
    data={{ items }}
    header={[
      {
        id: 0,
        uid: "rule",
        label: "Rule",
        render: item => <div>{item.ruleOperator || ""}</div>,
      },
      {
        id: 1,
        uid: "entity_type",
        label: "Entity Type",
        render: item => (
          <div>{item.entity_type === DATASTORE_ENTITY_TYPE ? "instance" : item.entity_type}</div>
        ),
      },
      {
        id: 2,
        uid: "match_type",
        label: "Match Type",
        render: item => <div>{item.rule.type}</div>,
      },
      {
        id: 3,
        uid: "rule_entity",
        label: "Rule text",
        render: item => (
          <div className="al-break-words">
            {item.entity_type === DATASTORE_ENTITY_TYPE
              ? getInstanceName(item.rule.entity, datastores ?? []) || item.rule.entity
              : item.rule.entity}
          </div>
        ),
      },
      {
        id: 4,
        uid: "created",
        label: "Created",
        render: item => (
          <div>
            <div>
              <b>{getUserName(item.created_by)}</b>
            </div>
            <div>{dayjs(item.created_at).format("DD MMM YYYY hh:mm")}</div>
          </div>
        ),
      },
      {
        id: 5,
        uid: "updated",
        label: "Updated",
        render: item => (
          <div>
            <div>
              <b>{getUserName(item.updated_by)}</b>
            </div>
            <div>{dayjs(item.updated_at).format("DD MMM YYYY hh:mm")}</div>
          </div>
        ),
      },
      {
        id: 6,
        uid: "actions",
        label: "Actions",
        render: item => (
          <div>
            {canManageRules ? (
              <DeleteWithConfirm
                entityId={item.id}
                id={groupId || ""}
                refetch={refetch}
                entityType="rule"
                title={`Delete rule ${item.rule.entity}`}
              />
            ) : null}
          </div>
        ),
      },
    ]}
  />
);

export default AccessRulesFlatTable;
